import { List } from 'immutable';

import State from './core/State';

const initialState: State = {
  authentication: {
    done: null,
    signedInUser: null,
    fetching: 0,
  },
  fatalError: null,
  fullScreenSpinner: {
    necessity: 0,
    loadingMessage: '',
  },
  language: 'JA',
  location: {
    pathname: '/',
    search: '',
  },
  nonFatalErrors: List(),
  snackbar: {
    message: null,
    messageValues: {},
    action: null,
    actionValues: {},
    isRaw: false,
    onClickAction: null,
    error: undefined,
  },
  translations: {},
  drawerOpen: false,
  countries: List(),
  locationCode: null,
  userPersonal: {
    personalInformation: null,
  },
  organization: {
    organizations: null,
    memberships: {
      memberships: null,
      invitations: null,
      spinnerNecessity: 0,
    },
    account: null,
  },
  new_account: {
    status: null,
  },
  acct: {
    billUser: null,
    productPricing: null,
    zenginBank: null,
    zenginBankAgent: null,
    userPayee: null,
    userPayeeAgent: null,
    bankAccount: null,
    bankAccountAgent: null,
    paymentHistory: null,
    paymentHistoryAgent: null,
    paymentDetails: null,
    paymentDetailsAgent: null,
    paymentExtProvider: null,
    paymentExtProviderAgent: null,
  },
  currentOrgOrAccount: null,
  currentAcctAccount: null,
  currentAcctAccountLoading: false,
  currentBfOrganization: null,
  currentBfOrganizationLoading: false,
  organizationFetched: false,
  bf: {
    availablePoint: null,
    budgets: null,
    pointTransactionHistory: null,
    childPointTransactionHistory: null,
    childPointTransactionsLoading: false,
  },
  currentAgent: null,

  agentMemberships: {
    nodes: [],
    pageInfo: {
      endCursor: null,
      startCursor: null,
      hasPreviousPage: null,
      hasNextPage: null,
    },
  },

  agentInvitation: {
    agent: null,
    enabled: null,
    id: null,
    token: null,
  },
};

export default initialState;
